module.exports = __webpack_public_path__ + "img/tgfwbg.a0c31d6b.png";